import JackpotWeights from "./jackpot-weights";

export default JackpotWeights;
